module.exports = __webpack_public_path__ + "img/no-pic.4c26eaf8.png";